import './Contact.css'
import React from 'react'
import Helmet from 'react-helmet'

// import Form from '../components/FormSimpleAjax'
import Content from '../components/Content'
import Map from '../components/Map'

// Export Template for use in CMS preview
export const ContactPageTemplate = ({ title, image, contactTitle, contactContent, locationTitle, locationContent, hoursTitle, hoursContent, infoTitle, infoContent }) => {

    return <main className="contact-page">
        <Helmet>
            <title>Assetlogue – Contact Us</title>
        </Helmet>
        {image && <div className='banner-image' style={{ backgroundImage: `url(${image.publicURL})` }}></div>}
        <div className='container'>
            {title && <h1>{title}</h1>}

            <div className='contact-container contact-form'>
                <iframe src="https://pipedrivewebforms.com/form/0d5c4b5140ffa6e4f911090c665fd9243343926"></iframe>                
                {/* <Form
                    submitButton='SEND'
                    formName='Get a Quote'
                >
                    <div className='input-row'>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="Name*"
                                name="first_name"
                                required
                            />
                        </label>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="Last Name*"
                                name="last_name"
                                required
                            />
                        </label>
                    </div>
                    <div className='input-row'>
                        <label className="Form--Label">
                            <input
                                className="Form--Input"
                                type="text"
                                placeholder="Email*"
                                name="email"
                                required
                            />
                        </label>
                        <label className="Form--Label">
                           <select name="enquiry_type">
                                <option value="" defaultValue>Select enquiry type*</option>
                                <option value="Option1">Option 1</option>
                                <option value="Option2">Option 2</option>
                                <option value="Option3">Option 3</option>
                           </select>
                        </label>
                    </div>
                    <label className="Form--Label">
                        <textarea
                            placeholder='Message'
                            className="Form--Input Form--Textarea"
                            name="message"
                            rows="10"
                            required
                        />
                    </label>
                </Form> */}

                <div>
                    {contactTitle && <h2>{contactTitle}</h2>}
                    {contactContent && <Content src={contactContent} />}
                    {locationTitle && <h3>{locationTitle}</h3>}
                    {locationContent && <Content src={locationContent} />}
                    <Map />
                    {hoursTitle && <h3>{hoursTitle}</h3>}
                    {hoursContent && <Content src={hoursContent} />}
                    {infoTitle && <h3>{infoTitle}</h3>}
                    {infoContent && <Content src={infoContent} />}
                </div>
            </div>

        </div>
    </main>
}

// Export Default HomePage for front-end
const ContactPage = ({ data: { page } }) => (
    <ContactPageTemplate {...page} {...page.frontmatter} body={page.html} />
)

export const pageQuery = graphql`
  ## Query for HomePage data
  ## Use GraphiQL interface (http://localhost:8000/___graphql)
  ## $id is processed via gatsby-node.js
  ## query name must be unique to this file
  query ContactPage($id: String!) {
    page: markdownRemark(id: { eq: $id }) {
      html
      frontmatter {
          title
          image {
              publicURL
          }
          contactTitle
          contactContent
          locationTitle
          locationContent
          hoursTitle
          hoursContent
          infoTitle
          infoContent
      }
    }
  }
`


export default ContactPage




// WEBPACK FOOTER //
// ./src/templates/ContactPage.js